import { jwtDecode } from 'jwt-decode'

// Get token from localStorage
export const getToken = () => {
  return localStorage.getItem('livtoken')
}

// Check if token is expired
export const isTokenExpired = (token) => {
  if (!token) return true

  try {
    const decoded = jwtDecode(token)
    const currentTime = Date.now() / 1000 // Convert to seconds
    // console.log(token);
    
    // Check if token is expired (with 60 second buffer)
    return decoded.exp < currentTime
  } catch (error) {
    // console.error('Error decoding token:', error)
    return true // If can't decode, consider it expired
  }
}

// Clear all auth data
export const clearAuthData = () => {
  localStorage.removeItem('livtoken')
  localStorage.removeItem('user')
  // Add any other auth-related items you store
  // Or use localStorage.clear() to clear everything
}

// Check token validity
export const checkTokenValidity = () => {
  const token = getToken()
  
  if (!token) {
    return false // No token
  }
  
  if (isTokenExpired(token)) {
    // console.log("hjh");
    
    clearAuthData()
    return false // Token expired
  }
  
  return true // Token is valid
}